"use strict";
function _slicedToArray(e, t) {
  return _arrayWithHoles(e) || _iterableToArrayLimit(e, t) || _unsupportedIterableToArray(e, t) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(e, t) {
  if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
    var o = [],
      n = !0,
      r = !1,
      a = void 0;
    try {
      for (var s, i = e[Symbol.iterator](); !(n = (s = i.next()).done) && (o.push(s.value), !t || o.length !== t); n = !0);
    } catch (e) {
      (r = !0), (a = e);
    } finally {
      try {
        n || null == i.return || i.return();
      } finally {
        if (r) throw a;
      }
    }
    return o;
  }
}
function _arrayWithHoles(e) {
  if (Array.isArray(e)) return e;
}
function asyncGeneratorStep(e, t, o, n, r, a, s) {
  try {
    var i = e[a](s),
      c = i.value;
  } catch (e) {
    return void o(e);
  }
  i.done ? t(c) : Promise.resolve(c).then(n, r);
}
function _asyncToGenerator(i) {
  return function () {
    var e = this,
      s = arguments;
    return new Promise(function (t, o) {
      var n = i.apply(e, s);
      function r(e) {
        asyncGeneratorStep(n, t, o, r, a, "next", e);
      }
      function a(e) {
        asyncGeneratorStep(n, t, o, r, a, "throw", e);
      }
      r(void 0);
    });
  };
}
function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  (e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } })), t && _setPrototypeOf(e, t);
}
function _setPrototypeOf(e, t) {
  return (_setPrototypeOf =
    Object.setPrototypeOf ||
    function (e, t) {
      return (e.__proto__ = t), e;
    })(e, t);
}
function _createSuper(o) {
  var n = _isNativeReflectConstruct();
  return function () {
    var e,
      t = _getPrototypeOf(o);
    return _possibleConstructorReturn(this, n ? ((e = _getPrototypeOf(this).constructor), Reflect.construct(t, arguments, e)) : t.apply(this, arguments));
  };
}
function _possibleConstructorReturn(e, t) {
  return !t || ("object" !== _typeof(t) && "function" != typeof t) ? _assertThisInitialized(e) : t;
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}
function _getPrototypeOf(e) {
  return (_getPrototypeOf = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
}
function _defineProperty(e, t, o) {
  return t in e ? Object.defineProperty(e, t, { value: o, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = o), e;
}
function _toConsumableArray(e) {
  return _arrayWithoutHoles(e) || _iterableToArray(e) || _unsupportedIterableToArray(e) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(e, t) {
  if (e) {
    if ("string" == typeof e) return _arrayLikeToArray(e, t);
    var o = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(e) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? _arrayLikeToArray(e, t) : void 0;
  }
}
function _iterableToArray(e) {
  if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
}
function _arrayWithoutHoles(e) {
  if (Array.isArray(e)) return _arrayLikeToArray(e);
}
function _arrayLikeToArray(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var o = 0, n = new Array(t); o < t; o++) n[o] = e[o];
  return n;
}
function _typeof(e) {
  return (_typeof =
    "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
      ? function (e) {
          return typeof e;
        }
      : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
}
function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, t) {
  for (var o = 0; o < t.length; o++) {
    var n = t[o];
    (n.enumerable = n.enumerable || !1), (n.configurable = !0), "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function _createClass(e, t, o) {
  return t && _defineProperties(e.prototype, t), o && _defineProperties(e, o), e;
}
function updateFreeShipping(e) {
  var t,
    o = parseFloat($(".js-cart__shipping-msg").data("minFree")),
    n = parseFloat(o) - parseFloat(e);
  o <= e
    ? ((t = $(".total__free-shipping").data("freeMsg")), $(".js-cart__shipping-msg").html(t))
    : ((n = theme.utils.toMoney(100 * n, { cents: !0 })), (t = window.theme.locales.cart.free_shipping_money_remaining.replace("[placeholder]", n)), $(".shipping-msg__price").text(n), $(".total__free-shipping").html(t));
}
function updateShippingSelectors(e) {
  $(".js-dropdown", e).each(function (e, t) {
    return new theme.Dropdown($(t));
  }),
    $(".js-shipping-method-selector", e).each(function (e, t) {
      return new theme.ShippingMethodChooser($(t));
    });
}
function reloadCartLayout() {
  var e = -1 < window.location.href.indexOf("/fr/") ? "fr/cart" : "/cart",
    o = $(".cart__container");
  return 0 === o.length
    ? $.when()
    : $.get(e + "?view=cart", function (e) {
        var t = $(e).find(".cart__container"),
          e = theme.cart.content.total_price / 100;
        o.html(t), updateFreeShipping(e), updateShippingSelectors(o);
      });
}
function reloadCartFlyout() {
  var e = -1 < window.location.href.indexOf("/fr") ? "fr/cart" : "/cart";
  return $.get(e + "?view=cart_flyout", function (e) {
    var t = $(e).find(".cart__flyout"),
      o = $("#cartpage-nosto-5");
    t.find("#cartpage-nosto-5").replaceWith(o);
    var n,
      r,
      e = $("#flyout");
    0 < e.find(".flyout--open").length && t.addClass("flyout--open"),
      e.html(t),
      updateShippingSelectors(e),
      $(".nav__cart").hasClass("open-on-refresh") && (0 == e.find(".flyout--open").length && toggleFlyout($(".nav__cart")), $(".nav__cart").removeClass("open-on-refresh").addClass("nav__util--active")),
      window.theme.settings.show_recommended_flyout &&
        o[0] &&
        o[0].children.length < 1 &&
        ((n = 0),
        (r = setInterval(function () {
          (n += 1), window.Nosto && (Nosto.reloadCart(["cartpage-nosto-5"]), clearInterval(r)), 10 < n && clearInterval(r);
        }, 1e3)));
  });
}
function createProductSlider(e, t) {
  e.slick({ slidesToShow: 7, slidesToScroll: 1, asNavFor: t, focusOnSelect: !0, vertical: !0, dots: !0, infinite: !1, draggable: !0, verticalSwiping: !0 }),
    t.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      focusOnSelect: !1,
      infinite: !1,
      dots: !0,
      arrows: !1,
      draggable: !1,
      responsive: [
        { breakpoint: 768, settings: { draggable: !1 } },
        { breakpoint: 0, settings: { draggable: !0 } },
      ],
    });
  t.on("beforeChange", function (e, t, o, n) {
    var r,
      a = $(".image__gallery");
    a.length && ((r = "is-active-spin-studio-slide"), $(t.$slides.get(n)).hasClass("-spin-studio-active-wrapper") ? a.addClass(r) : a.removeClass(r));
  });
}
function updateVariantPrice(e) {
  $(".product__details .price").hide(), $(".price-variant-" + e).show();
}

function addBundleItemToCart(bundle_product_ids,get_size_val,get_color_val,main_p_variant_id)
{
  let items_arr = [];
  let variants_arr = [];

  for(var i = 0;i< bundle_product_ids.length;i++)
  {
    let variant_id = getBundleItemVariantID(bundle_product_ids[i],get_size_val,get_color_val,main_p_variant_id);
    if(variant_id in variants_arr)
    {
      variants_arr[variant_id] = variants_arr[variant_id] + 1;
    }
    else 
    {
      variants_arr[variant_id] = 1;
    }
  }
  for(var key in variants_arr)
  {
    let item_obj = {id: key , quantity:variants_arr[key], properties: {"_bundle_item_variant_id": main_p_variant_id} };
    items_arr.push(item_obj);
  }

  $.ajax({ url: "/cart/add.js", data: {items: items_arr}, type: "POST", dataType: "json" })
  .done(function () {
    $(".nav__cart").addClass("open-on-refresh"),
      $(".product__cart-error").empty(),
      -1 < window.location.href.indexOf("fromCart") && ($(".js-flyout-overlay").removeClass("flyout__overlay--active"), $(document.body).removeClass("scroll-hidden"));
  })
  .fail(function (e) {
    422 == e.status && ((e = e.responseJSON), $(".product__cart-error").text(e.description));
  });
}

function updateBundleSkus(bundle_product_ids,get_size_val,get_color_val)
{
   let b_skus = "";
   for(var i = 0;i< bundle_product_ids.length;i++)
    {
      let selected_sku = getBundleItemSku(bundle_product_ids[i],get_size_val,get_color_val);
      if(i != bundle_product_ids.length - 1)
      {
        b_skus = b_skus + selected_sku + ", ";
      }
      else 
      {
        b_skus = b_skus + selected_sku;
      }
    }
    if(b_skus != "")
    {
      $('#bundle_skus').val(b_skus);
    }
}

function getBundleItemSku(bundle_product_id,get_size_val,get_color_val)
{
  let sku_selected = "";
      let p_handle = $('#p_'+bundle_product_id).val() + ".js";
      let p_url = window.Shopify.routes.root + 'products/'+ p_handle;
      $.ajax({ url: p_url,type: "GET", dataType: "json",async: false })
      .done(function (p) {
        sku_selected = getSelectedSku(p,get_size_val,get_color_val); 
      })
      .fail(function (e) {
        console.log(e);
      })
      .then(function(p){
         
      });
  return sku_selected;
}

function getBundleItemVariantID(bundle_product_id,get_size_val,get_color_val)
{
  let variant_id_selected = "";
      let p_handle = $('#p_'+bundle_product_id).val() + ".js";
      let p_url = window.Shopify.routes.root + 'products/'+ p_handle;
      $.ajax({ url: p_url,type: "GET", dataType: "json",async: false })
      .done(function (p) {
        variant_id_selected = getSelectedVariantID(p,get_size_val,get_color_val); 
      })
      .fail(function (e) {
        console.log(e);
      })
      .then(function(p){
         
      });
  return variant_id_selected;
}

function getSelectedSku(p,get_size_val,get_color_val)
{
  let sku_selected = p.variants[0]["sku"];
  let p_size_option_index =0;
  let p_color_option_index=0;
  if(get_size_val != "" || get_color_val != "")
  {
    for(var i=0;i<p.options.length;i++)
    {
      if(p.options[i]["name"].toLowerCase() == "size")
      {
        p_size_option_index = i+1;
      }
      if(p.options[i]["name"].toLowerCase() == "color" || p.options[i]["name"].toLowerCase() == "colour") 
      {
        p_color_option_index = i+1;
      }
    }
    if(p_size_option_index > 0 || p_color_option_index > 0)
    {
      for(var i = 0; i< p.variants.length;i++)
      {
        if(p_size_option_index > 0 && p_color_option_index == 0)
        {
          if(p.variants[i]["option"+p_size_option_index] == get_size_val)
            {
              sku_selected = p.variants[i].sku;
              break;
            }
        }

        if(p_size_option_index == 0 && p_color_option_index > 0)
        {
          if(p.variants[i]["option"+p_color_option_index] == get_color_val)
            {
              sku_selected = p.variants[i].sku;
              break;
            }
        }

        if(p_size_option_index > 0 && p_color_option_index > 0)
        {
          if(p.variants[i]["option"+p_size_option_index] == get_size_val && p.variants[i]["option"+p_color_option_index] == get_color_val)
          {
            sku_selected = p.variants[i].sku;
            break;
          }
        }
        
      }  
    }
    
  }
  return sku_selected;
}

function getSelectedVariantID(p,get_size_val,get_color_val)
{

  let variant_id_selected = p.variants[0]["id"];
  let p_size_option_index =0;
  let p_color_option_index=0;
  let find_mixed_variant = false;
  if(get_size_val != "" || get_color_val != "")
  {
    for(var i=0;i<p.options.length;i++)
    {
      if(p.options[i]["name"].toLowerCase() == "size")
      {
        p_size_option_index = i+1;
      }
      if(p.options[i]["name"].toLowerCase() == "color" || p.options[i]["name"].toLowerCase() == "colour") 
      {
        p_color_option_index = i+1;
      }
    }
    if(p_size_option_index > 0 || p_color_option_index > 0)
    {
      for(var i = 0; i< p.variants.length;i++)
      {
        if(p_size_option_index > 0 && p_color_option_index == 0)
        {
          if(p.variants[i]["option"+p_size_option_index] == get_size_val)
            {
              variant_id_selected = p.variants[i].id;
              break;
            }
        }

        if(p_size_option_index == 0 && p_color_option_index > 0)
        {
          if(p.variants[i]["option"+p_color_option_index] == get_color_val)
            {
              
              variant_id_selected = p.variants[i].id;
              break;
            }
        }

        if(p_size_option_index > 0 && p_color_option_index > 0)
        {
              
          if(p.variants[i]["option"+p_size_option_index] == get_size_val && p.variants[i]["option"+p_color_option_index] == get_color_val)
          {
            variant_id_selected = p.variants[i].id;
            find_mixed_variant = true;
            break;
          }
          if(!find_mixed_variant)
          {
            if(p.variants[i]["option"+p_size_option_index] == get_size_val)
            {
              variant_id_selected = p.variants[i].id;
            }
          }
        }
        
      }  
    }
    
  }
  return variant_id_selected;
}
function createCardSlider(e) {
  767 < $(window).width() && $(e).hasClass("slick-initialized")
    ? $(e).slick("unslick")
    : $(window).width() < 768 &&
      !$(e).hasClass("slick-initialized") &&
      (1 == $(e).children().length
        ? $(e).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            focusOnSelect: !1,
            infinite: !1,
            dots: !1,
            arrows: !1,
            draggable: !1,
            responsive: [
              { breakpoint: 768, settings: { draggable: !1 } },
              { breakpoint: 0, settings: { draggable: !0 } },
            ],
          })
        : $(e).slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            focusOnSelect: !1,
            infinite: !1,
            dots: !1,
            arrows: !1,
            draggable: !1,
            responsive: [
              { breakpoint: 768, settings: { draggable: !1 } },
              { breakpoint: 0, settings: { draggable: !0 } },
            ],
          }));
}
function getSelectedProductID(e, t) {
  var o = e.find(t);
  return (o.is("select") ? o.find("option:selected") : o.is("input[type=radio]") ? e.find(t + ":checked") : o).val();
}
function addToCart(e, t, o) {
  var n = { quantity: 1 },
    e = e;
  0 < o.length && (n.quantity = o.val()),
    0 < e.length && (n.id = getSelectedProductID(e, t)),
    theme.cart.add(n).then(function () {
      -1 < window.location.href.indexOf("fromCart") && (window.location.href = window.theme.shop.url + "/cart");
    });
}
function triggerShipmentModal(n) {
  return n.modal
    ? $.when(theme.customer.getPreferredStore(), theme.customer.getPreferredShipping()).then(function (e, t) {
        var o = $.Deferred();
        if (!e.store_code || t) return o.reject(), o.promise();
        return (
          $("[data-shipment-form]")
            .off("submit.shipment_modal")
            .on("submit.shipment_modal", function (e) {
              e.preventDefault(),
                theme.customer.setPreferredShipping($('[name="shipping-method"]:checked').val()).done(function () {
                  return o.resolve();
                }, n.hide());
            }),
          $("#modal-shipping-method")
            .off("modal_show.shipment_modal")
            .on("modal_show.shipment_modal", function (e) {
              var t = $(e.target),
                e = $(t.find("[data-shipment-method]"));
              $(t.find('[data-shipping="'.concat("ship_to_store", '"] input[type="radio"]'))).prop("disabled", e.hasClass("status--unavailable"));
            }),
          n.show(),
          o.promise()
        );
      })
    : $.Deferred().reject().promise();
}
function toggleFlyout(e) {
  var t = e.data("flyoutToggle"),
    o = $(".js-flyout-overlay");
  "" != t &&
    ((t = ".".concat(t, "__flyout")),
    $(".flyout--open").not(t).removeClass("flyout--open"),
    $(t).toggleClass("flyout--open"),
    o.toggleClass("flyout__overlay--active"),
    $(document.body).toggleClass("scroll-hidden"),
    $(".nav__util--active").not($(e)).removeClass("nav__util--active"),
    $(e).toggleClass("nav__util--active"),
    $(".search__input").removeAttr("role"));
}
function removeLineItem(e) {
  theme.cart.remove(e).then(function (e) {
    var t;
    0 == e.total_price
      ? ((t = "$0.00"),
        theme.cart.clear(),
        0 == e.item_count && ($(".flyout__contents__contain").append('<div class="flyout__contents__empty"><p>You have no items in your shopping cart.</p></div>'), $(".flyout__footer").addClass("flyout__footer--hide")))
      : ((t = theme.utils.toMoney(e.total_price, { cents: !0 })), $(".flyout__footer").removeClass("flyout__footer--hide")),
      $(".nav__cart .cart__count").text(e.item_count),
      $(".flyout__footer__total .subtotal--money").text(t);
  });
}
!(function (o) {
  var e = (function () {
    function e() {
      _classCallCheck(this, e), this._handleize();
    }
    return (
      _createClass(e, [
        {
          key: "_handleize",
          value: function () {
            for (
              var e = [
                  { base: "A", letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ" },
                  { base: "AA", letters: "Ꜳ" },
                  { base: "AE", letters: "ÆǼǢ" },
                  { base: "AO", letters: "Ꜵ" },
                  { base: "AU", letters: "Ꜷ" },
                  { base: "AV", letters: "ꜸꜺ" },
                  { base: "AY", letters: "Ꜽ" },
                  { base: "B", letters: "BⒷＢḂḄḆɃƂƁ" },
                  { base: "C", letters: "CⒸＣĆĈĊČÇḈƇȻꜾ" },
                  { base: "D", letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ" },
                  { base: "DZ", letters: "ǱǄ" },
                  { base: "Dz", letters: "ǲǅ" },
                  { base: "E", letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ" },
                  { base: "F", letters: "FⒻＦḞƑꝻ" },
                  { base: "G", letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ" },
                  { base: "H", letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ" },
                  { base: "I", letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ" },
                  { base: "J", letters: "JⒿＪĴɈ" },
                  { base: "K", letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ" },
                  { base: "L", letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ" },
                  { base: "LJ", letters: "Ǉ" },
                  { base: "Lj", letters: "ǈ" },
                  { base: "M", letters: "MⓂＭḾṀṂⱮƜ" },
                  { base: "N", letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ" },
                  { base: "NJ", letters: "Ǌ" },
                  { base: "Nj", letters: "ǋ" },
                  { base: "O", letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ" },
                  { base: "OI", letters: "Ƣ" },
                  { base: "OO", letters: "Ꝏ" },
                  { base: "OU", letters: "Ȣ" },
                  { base: "OE", letters: "Œ" },
                  { base: "oe", letters: "œ" },
                  { base: "P", letters: "PⓅＰṔṖƤⱣꝐꝒꝔ" },
                  { base: "Q", letters: "QⓆＱꝖꝘɊ" },
                  { base: "R", letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ" },
                  { base: "S", letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ" },
                  { base: "T", letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ" },
                  { base: "TZ", letters: "Ꜩ" },
                  { base: "U", letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ" },
                  { base: "V", letters: "VⓋＶṼṾƲꝞɅ" },
                  { base: "VY", letters: "Ꝡ" },
                  { base: "W", letters: "WⓌＷẀẂŴẆẄẈⱲ" },
                  { base: "X", letters: "XⓍＸẊẌ" },
                  { base: "Y", letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ" },
                  { base: "Z", letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ" },
                  { base: "a", letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ" },
                  { base: "aa", letters: "ꜳ" },
                  { base: "ae", letters: "æǽǣ" },
                  { base: "ao", letters: "ꜵ" },
                  { base: "au", letters: "ꜷ" },
                  { base: "av", letters: "ꜹꜻ" },
                  { base: "ay", letters: "ꜽ" },
                  { base: "b", letters: "bⓑｂḃḅḇƀƃɓ" },
                  { base: "c", letters: "cⓒｃćĉċčçḉƈȼꜿↄ" },
                  { base: "d", letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ" },
                  { base: "dz", letters: "ǳǆ" },
                  { base: "e", letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ" },
                  { base: "f", letters: "fⓕｆḟƒꝼ" },
                  { base: "g", letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ" },
                  { base: "h", letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ" },
                  { base: "hv", letters: "ƕ" },
                  { base: "i", letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı" },
                  { base: "j", letters: "jⓙｊĵǰɉ" },
                  { base: "k", letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ" },
                  { base: "l", letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ" },
                  { base: "lj", letters: "ǉ" },
                  { base: "m", letters: "mⓜｍḿṁṃɱɯ" },
                  { base: "n", letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ" },
                  { base: "nj", letters: "ǌ" },
                  { base: "o", letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ" },
                  { base: "oi", letters: "ƣ" },
                  { base: "ou", letters: "ȣ" },
                  { base: "oo", letters: "ꝏ" },
                  { base: "p", letters: "pⓟｐṕṗƥᵽꝑꝓꝕ" },
                  { base: "q", letters: "qⓠｑɋꝗꝙ" },
                  { base: "r", letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ" },
                  { base: "s", letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ" },
                  { base: "t", letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ" },
                  { base: "tz", letters: "ꜩ" },
                  { base: "u", letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ" },
                  { base: "v", letters: "vⓥｖṽṿʋꝟʌ" },
                  { base: "vy", letters: "ꝡ" },
                  { base: "w", letters: "wⓦｗẁẃŵẇẅẘẉⱳ" },
                  { base: "x", letters: "xⓧｘẋẍ" },
                  { base: "y", letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ" },
                  { base: "z", letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ" },
                ],
                n = {},
                t = 0;
              t < e.length;
              t++
            )
              for (var o = e[t].letters.split(""), r = 0; r < o.length; r++) n[o[r]] = e[t].base;
            (String.prototype.noAccents = function (e, t) {
              var o = this.replace(/[^\u0000-\u007E]/g, function (e) {
                return n[e] || e;
              });
              return (t = t || ""), e && (o = o.replace(/[^\u0000-\u007E]/g, t)), o;
            }),
              (String.prototype.handleize = function (e, t) {
                return (
                  (e = e || "-"),
                  (t = t || ""),
                  this.noAccents(!0, t)
                    .trim()
                    .replace(/[^a-z0-9\s-]/gi, t)
                    .replace(/\s/gi, e)
                    .toLowerCase()
                );
              });
          },
        },
        {
          key: "toMoney",
          value: function (e, t) {
            if (!e && e < 0) return console.error("Utilities.toMoney: Invalid price passed.", e), null;
            e = new Number(e);
            return (
              ((t = t || {}).cents = t.cents || !1),
              (t.locale = t.locale || (o.shop ? o.shop.locale : null) || "en-CA"),
              (t.currency = t.currency || (o.shop ? o.shop.currency : null) || "CAD"),
              t.cents && (e /= 100),
              e.toLocaleString(t.locale, { style: "currency", currency: t.currency })
            );
          },
        },
        {
          key: "removeProtocol",
          value: function (e) {
            return e ? e.replace(/http(s)?:/, "") : (console.error("Utilities.removeProtocol: Invalid path passed.", e), null);
          },
        },
        {
          key: "getSizedImageUrl",
          value: function (e, t) {
            if (!t) return console.error("Utilities.getSizedImageUrl: Invalid size passed.", t), e;
            if ("master" === t) return this.removeProtocol(e);
            var o = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
            if (o) {
              var n = e.split(o[0]),
                o = o[0];
              return this.removeProtocol(n[0] + "_" + t + o);
            }
            return console.error("Utilities.getSizedImageUrl: Invalid image URL passed.", e), null;
          },
        },
        {
          key: "toObject",
          value: function (e) {
            var t = {};
            return e
              ? ((e = decodeURIComponent(e)).split("&").forEach(function (e) {
                  e = e.split("=");
                  t[e[0]] = e[1] || null;
                }),
                t)
              : {};
          },
        },
        {
          key: "getURLParams",
          value: function (e) {
            e = (e = e || window.location.href).split(/\?(.+)/)[1];
            return e ? this.toObject(e) : {};
          },
        },
      ]),
      e
    );
  })();
  o.utils = new e();
})((window.theme = window.theme || {})),
  (function (e, i) {
    var t = (function () {
      function t(e) {
        _classCallCheck(this, t), (this.content = e || {}), e || this.fetch();
      }
      return (
        _createClass(t, [
          {
            key: "content",
            get: function () {
              return this._object;
            },
            set: function (e) {
              (this._object = e || this._object), i(document).trigger("cart_set", this.content);
            },
          },
          {
            key: "fetch",
            value: function () {
              var t = this;
              return i
                .ajax({ url: "/cart.js", type: "GET", dataType: "json" })
                .done(function (e) {
                  (t.content = e), i(document).trigger("cart_fetch", t.content);
                })
                .fail(function (e) {
                  console.error("Cart.fetch: Error getting the cart.", e);
                });
            },
          },
          {
            key: "add",
            value: function (e) {
              var t = this;
              return e
                ? ("object" != _typeof(e) && (e = { id: e }),
                  (e.quantity = e.quantity || 1),
                  i
                    .ajax({ url: "/cart/add.js", data: e, type: "POST", dataType: "json" })
                    .done(function (e) {
                      t.fetch(), i(document).trigger("cart_add", e);
                    })
                    .fail(function (e) {
                      console.error("Cart.add: Error adding to the cart.", e);
                    }))
                : (console.error("Cart.add: No item was passed."), !1);
            },
          },
          {
            key: "update",
            value: function (t, e) {
              var o = this;
              if (!t) return console.error("Cart.update: No item was passed."), !1;
              function n(e) {
                if ("object" === _typeof(e)) {
                  if (!e.id) return console.error("Cart.update: No id was passed with the product object."), 0;
                  r[e.id] = e.quantity || 0 === e.quantity ? e.quantity : 1;
                } else r[e] = 1;
              }
              var r = {};
              return (
                Array.isArray(t)
                  ? t.forEach(function (e) {
                      n(e);
                    })
                  : n(t),
                0 !== Object.keys(r).length &&
                  ("remove" !== e && i(".js-flyout-overlay").addClass("flyout__overlay--active"),
                  i(".js-loader-overlay").addClass("flyout__loader-overlay--active"),
                  i(".js-flyout-loader").addClass("flyout__loader--active"),
                  i
                    .ajax({ url: "/cart/update.js", data: { updates: r }, type: "POST", dataType: "json" })
                    .done(function (e) {
                      (o.content = e), i("#flyout .flyout__fail-msg").removeClass("flyout__fail-msg--active"), i("#flyout .flyout__success-msg").addClass("flyout__success-msg--active"), i(document).trigger("cart_update", [e, t]);
                    })
                    .fail(function (e) {
                      i("#flyout .flyout__success-msg").removeClass("flyout__success-msg--active"), i("#flyout .flyout__fail-msg").addClass("flyout__fail-msg--active"), console.error("Cart.update: Error updating a cart item.", e);
                    })
                    .always(function () {
                      i(".js-loader-overlay").removeClass("flyout__loader-overlay--active"), i(".js-flyout-loader").removeClass("flyout__loader--active");
                    }))
              );
            },
          },
          {
            key: "change",
            value: function (t) {
              var o = this;
              return t
                ? ("object" != _typeof(t) && (t = { id: t }),
                  (t.quantity = t.quantity || 1),
                  i
                    .ajax({ url: "/cart/change.js", data: t, type: "POST", dataType: "json" })
                    .done(function (e) {
                      (o.content = e), i(document).trigger("cart_change", [e, t]);
                    })
                    .fail(function (e) {
                      console.error("Cart.change: Error changing a cart quantity.", e);
                    }))
                : (console.error("Cart.change: No item was passed."), !1);
            },
          },
          {
            key: "remove",
            value: function (e) {
              if (!e) return console.error("Cart.remove: No item was passed."), !1;
              var t = [];
              return (
                Array.isArray(e)
                  ? e.forEach(function (e) {
                      t.push({ id: "object" === _typeof(e) ? e.id : e, quantity: 0 });
                    })
                  : t.push({ id: "object" === _typeof(e) ? e.id : e, quantity: 0 }),
                this.update(t)
              );
            },
          },
          {
            key: "clear",
            value: function () {
              var t = this;
              return i
                .ajax({ url: "/cart/clear.js", type: "POST", dataType: "json" })
                .done(function (e) {
                  (t.content = e), i(document).trigger("cart_clear", e);
                })
                .fail(function (e) {
                  console.error("Cart.clear: Error clearing the cart.", e);
                });
            },
          },
          {
            key: "updateAttributes",
            value: function (e, t) {
              var o = this;
              if (!e) return console.warn("Cart.updateAttribute: No attributes were passed."), i.when();
              var n = {};
              if ((t = t || {}).no_overwrite)
                for (var r = 0, a = Object.keys(e); r < a.length; r++) {
                  var s = a[r];
                  this.content.attributes[s] || (n[s] = e[s]);
                }
              else n = e;
              return Object.keys(n).length
                ? ("note" in (n = { attributes: n }).attributes && (n.note = n.attributes.note),
                  i
                    .ajax({ url: "/cart/update.js", data: n, type: "POST", dataType: "json" })
                    .done(function (e) {
                      (o.content = e), i(document).trigger("cart_update", [e, n]);
                    })
                    .fail(function (e) {
                      console.error("Cart.attributeUpdate: Failed updating a cart attribute.", e);
                    }))
                : i.when();
            },
          },
        ]),
        t
      );
    })();
    e.cart = new t(e.cart_json || null);
  })((window.theme = window.theme || {}), jQuery),
  (function (e) {
    var t = (function () {
      function o(e, t) {
        _classCallCheck(this, o), (this.latitude = e), (this.longitude = t);
      }
      return (
        _createClass(o, [
          {
            key: "getLatitude",
            value: function () {
              return this.latitude;
            },
          },
          {
            key: "getLongitude",
            value: function () {
              return this.longitude;
            },
          },
          {
            key: "getPosition",
            value: function () {
              return { latitude: this.latitude, longitude: this.longitude };
            },
          },
          {
            key: "getLatLng",
            value: function () {
              return { lat: parseFloat(this.latitude), lng: parseFloat(this.longitude) };
            },
          },
        ]),
        o
      );
    })();
    (t.prototype.toString = function () {
      return JSON.stringify(this.getPosition());
    }),
      (e.Coordinates = t);
  })((window.theme = window.theme || {})),
  (function (e, t) {
    var o = (function () {
      function o() {
        _classCallCheck(this, o), (this._deferred = t.Deferred());
      }
      return (
        _createClass(
          o,
          [
            {
              key: "_locateUser",
              value: function () {
                var t = this,
                  e = sessionStorage.getItem("user_location");
                if (e) return this._deferred.resolve(JSON.parse(e));
                try {
                  geoip2.city(
                    function (e) {
                      sessionStorage.setItem(o.STORAGE_KEYS.user_location, JSON.stringify(e)), t._deferred.resolve(e);
                    },
                    function (e) {
                      console.warn("Geolocation._locateUser:", e.error), t._deferred.reject(e);
                    }
                  );
                } catch (e) {
                  console.warn("Geolocation._locateUser:", e), this._deferred.reject();
                }
                return this._deferred.promise();
              },
            },
            {
              key: "getUserLocation",
              value: function () {
                return this._locateUser().then(function (e) {
                  return { longitude: e.location.longitude, latitude: e.location.latitude };
                });
              },
            },
          ],
          [
            {
              key: "STORAGE_KEYS",
              get: function () {
                return Object.freeze({ user_location: "user_location" });
              },
            },
          ]
        ),
        o
      );
    })();
    e.geolocation = new o();
  })((window.theme = window.theme || {}), jQuery),
  (function (e) {
    var t = (function () {
      function t(e) {
        _classCallCheck(this, t), (this._data = e || {});
      }
      return (
        _createClass(t, [
          {
            key: "store_code",
            get: function () {
              return this._data.store_code;
            },
          },
          {
            key: "address_name",
            get: function () {
              return this.getAddress().city;
            },
          },
          {
            key: "address_street",
            get: function () {
              return this.getAddress().street;
            },
          },
          {
            key: "address_line1",
            get: function () {
              return this.getAddress().address1;
            },
          },
          {
            key: "address_line2",
            get: function () {
              return this.getAddress().address2;
            },
          },
          {
            key: "address_city",
            get: function () {
              return this.getAddress().city;
            },
          },
          {
            key: "address_province",
            get: function () {
              return this.getAddress().province;
            },
          },
          {
            key: "address_province_code",
            get: function () {
              return this.getAddress().province_code;
            },
          },
          {
            key: "address_postal_code",
            get: function () {
              return this.getAddress().postal_code;
            },
          },
          {
            key: "address_country",
            get: function () {
              return this.getAddress().country;
            },
          },
          {
            key: "address_country_code",
            get: function () {
              return this.getAddress().country_code;
            },
          },
          {
            key: "phone",
            get: function () {
              return this._data.phone;
            },
          },
          {
            key: "latitude",
            get: function () {
              return this.getAddress().latitude;
            },
          },
          {
            key: "longitude",
            get: function () {
              return this.getAddress().longitude;
            },
          },
          {
            key: "open",
            get: function () {
              return this._data.open && this.openInStore;
            },
          },
          {
            key: "openInStore",
            get: function () {
              return !("in_store_shopping" in this._data) || this._data.in_store_shopping;
            },
          },
          {
            key: "today_hours",
            get: function () {
              return this.getTodayHours();
            },
          },
          {
            key: "tomorrow_hours",
            get: function () {
              return this.getTomorrowHours();
            },
          },
          {
            key: "hours",
            get: function () {
              return this.getHours();
            },
          },
          {
            key: "schedule",
            get: function () {
              var e = _toConsumableArray(this.getHours());
              return (
                e.push(e.shift()),
                e.reduce(function (e, t) {
                  var o = e[e.length - 1];
                  return o && t.open_time == o.open_time && t.close_time == o.close_time ? o.day.push(t.day) : e.push({ day: [t.day], open_time: t.open_time, close_time: t.close_time }), e;
                }, [])
              );
            },
          },
          {
            key: "distance",
            get: function () {
              return isNaN(this._data.distance) ? "" : Math.round(this._data.distance) + "km";
            },
          },
          {
            key: "name",
            get: function () {
              return this._data.name;
            },
          },
          {
            key: "getAddress",
            value: function () {
              return this._data.address || {};
            },
          },
          {
            key: "getHours",
            value: function () {
              return this._data.open_hours || [];
            },
          },
          {
            key: "getTodayHours",
            value: function () {
              return (this.openInStore && this.getHours()[new Date().getDay()]) || null;
            },
          },
          {
            key: "getTomorrowHours",
            value: function () {
              return (this.openInStore && this.getHours()[new Date().getDay() + 1]) || null;
            },
          },
          {
            key: "getDirectionsUrl",
            value: function (e) {
              var t = "https://www.google.com/maps/dir/?api=1";
              return (
                (t += "&destination=" + encodeURIComponent("".concat(this.address_street, ", ").concat(this.address_city, ", ").concat(this.address_province, " ").concat(this.address_postal_code))),
                e && (t += "&origin=" + encodeURIComponent(e.latitude + "," + e.longitude)),
                t
              );
            },
          },
          {
            key: "getLatLng",
            value: function () {
              return { lat: this.getAddress().latitude, lng: this.getAddress().longitude };
            },
          },
        ]),
        t
      );
    })();
    (t.prototype.toString = function () {
      return JSON.stringify(this._data);
    }),
      (e.StoreLocation = t);
  })((window.theme = window.theme || {})),
  (function (s, n) {
    var e = (function () {
      function a(e) {
        var t = this;
        _classCallCheck(this, a),
          (this.stores = []),
          (this.currentPageStores = []),
          (this.currentPage = 1),
          (this.pageSize = 5),
          (this.endpoint = "/apps/integrations-api/v1/stores"),
          this.map,
          (this.mapElement = document.getElementById("map")),
          (this.markers = {}),
          this.selectedStore,
          e &&
            (n(e).on("submit", function (e) {
              e.preventDefault(), t.getStoresByAddress(n(e.currentTarget).find(".js-input").val());
            }),
            n(".js-user-location").on("click", this.getStoresByPosition.bind(this)),
            n("[data-paginate-store]").on("click", function (e) {
              return t.setCurrentPage(t.currentPage + parseInt(e.currentTarget.dataset.paginateStore));
            })),
          this.mapElement && (this.location = this.setLocation(Number(n(this.mapElement).attr("data-center-lat")), Number(n(this.mapElement).attr("data-center-lng")))),
          (this.geocoderPromise = n.Deferred()),
          (window.initMap = function () {
            return t.initMap();
          });
        e = document.createElement("script");
        e.setAttribute("src", "https://maps.googleapis.com/maps/api/js?key=AIzaSyDnzoHLG1osn3GsTeJSM7yxJiFayTG0HXI&callback=initMap"),
          document.querySelector('script[src="' + e.src + '"]') ? window.google && google.maps && this.initMap() : document.getElementsByTagName("head")[0].appendChild(e);
      }
      return (
        _createClass(
          a,
          [
            {
              key: "setStores",
              value: function (e) {
                return (this.stores = e), this.setCurrentPage(1), this.stores;
              },
            },
            {
              key: "setCurrentPage",
              value: function (e) {
                return (
                  (this.currentPage = Math.max(Math.min(e, Math.ceil(this.stores.length / this.pageSize)), 1)),
                  (this.currentPageStores = this.stores.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)),
                  this.displayPage(),
                  this.updatePagination(),
                  this.currentPage
                );
              },
            },
            {
              key: "setLocation",
              value: function (e, t) {
                return (this.location = new s.Coordinates(e, t)), this.location;
              },
            },
            {
              key: "initMap",
              value: function () {
                this.geocoderPromise.resolve(new google.maps.Geocoder()),
                  this.mapElement && ((this.map = new google.maps.Map(this.mapElement, { center: this.location.getLatLng(), maxZoom: 16, zoom: 10, disableDefaultUI: !0 })), this.renderMarkers());
              },
            },
            {
              key: "getGeocoder",
              value: function () {
                return this.geocoderPromise.promise();
              },
            },
            {
              key: "getStores",
              value: function (e) {
                var t = this,
                  e = { latitude: this.location.getLatitude(), longitude: this.location.getLongitude(), radius: 1e3, units: "km", brands: ["boathouse"], limit: 10 };
                return n.get(this.endpoint, e).then(
                  function (e) {
                    return t.setStores(
                      e.stores.map(function (e) {
                        return new s.StoreLocation(e);
                      })
                    );
                  },
                  function (e) {
                    return [];
                  }
                );
              },
            },
            {
              key: "getStoreByCode",
              value: function (t) {
                return this.stores.filter(function (e) {
                  return e.store_code == t;
                })[0];
              },
            },
            {
              key: "getStoresByPosition",
              value: function () {
                var t = this;
                this.getPosition().then(
                  function (e) {
                    t.setLocation(e.coords.latitude, e.coords.longitude), t.getStores(), t.updateSearchTitle("position");
                  },
                  function (e) {
                    t.setStores([]), n(".js-loc-disabled").addClass("c-store-locator__stores-location-disabled--active");
                  }
                );
              },
            },
            {
              key: "getStoresByAddress",
              value: function (e) {
                var t = this;
                this.geocodeAddress(e)
                  .then(
                    function (e) {
                      t.setLocation(e.lat(), e.lng()), t.getStores();
                    },
                    function (e) {
                      t.setStores([]);
                    }
                  )
                  .always(function () {
                    t.updateSearchTitle("address", e);
                  });
              },
            },
            {
              key: "getPosition",
              value: function () {
                var t = n.Deferred();
                return (
                  navigator.geolocation.getCurrentPosition(
                    function (e) {
                      return t.resolve(e);
                    },
                    function (e) {
                      return t.reject(e);
                    }
                  ),
                  t.promise()
                );
              },
            },
            {
              key: "geocodeAddress",
              value: function (t) {
                var o = n.Deferred();
                return (
                  this.getGeocoder().done(function (e) {
                    e.geocode({ address: t, componentRestrictions: { country: "CA" } }, function (e, t) {
                      "OK" == t ? o.resolve(e[0].geometry.location) : o.reject(t);
                    });
                  }),
                  o.promise()
                );
              },
            },
            {
              key: "displayPage",
              value: function () {
                if (0 === this.stores.length) return n(".js-stores").html(""), void n(".js-store-locator").addClass("c-store-locator--no-results");
                n(".js-loc-disabled").removeClass("c-store-locator__stores-location-disabled--active"),
                  n(".js-store-locator").removeClass("c-store-locator--no-results"),
                  n(".js-stores").html(this.currentPageStores.reduce(this.renderStore.bind(this), "")),
                  this.renderMarkers(),
                  this.updatePagination();
              },
            },
            {
              key: "renderStore",
              value: function (e, t) {
                var o = ("0" + new Date().getHours()).slice(-2) + ":" + new Date().getMinutes(),
                  n = "";
                return (
                  t.getHours().length &&
                    (n = t.schedule.reduce(function (e, t) {
                      return (
                        e +
                        '\n\t\t\t\t\t\t<div class="store__store-weekly-hours">\n\t\t\t\t\t\t\t<strong>\n\t\t\t\t\t\t\t\t'
                          .concat(
                            t.day
                              .filter(function (e, t, o) {
                                return 0 == t || t == o.length - 1;
                              })
                              .join("-"),
                            "\n\t\t\t\t\t\t\t</strong>:\n\t\t\t\t\t\t\t"
                          )
                          .concat(t.open_time, "-")
                          .concat(t.close_time, "\n\t\t\t\t\t\t</div>\n\t\t\t\t\t")
                      );
                    }, '<div class="store__store-hours js-show-hours">Store Hours</div>')),
                  e +
                    '<div id="' +
                    t.store_code +
                    '" class="store js-store' +
                    (this.selectedStore && this.selectedStore.store_code == t.store_code ? " store--selected" : "") +
                    '"><div class="store__name">' +
                    t.name +
                    '</div><div class="store__distance">' +
                    t.distance +
                    '</div><div class="store__address">' +
                    t.address_street +
                    "<br />" +
                    t.address_city +
                    ", " +
                    t.address_province_code +
                    " " +
                    t.address_postal_code +
                    "<br />" +
                    t.phone +
                    '</div><div class="store__open-hours">' +
                    (t.open ? "<strong>Open</strong>" : "<strong>Closed</strong>") +
                    (t.today_hours ? " until " + (t.open ? t.today_hours.close_time : (o > t.today_hours.close_time ? t.tomorrow_hours : t.today_hours).open_time) : "") +
                    '</div><div class="store__selector"><button type="button" class="js-store-chooser" data-store-code="' +
                    t.store_code +
                    '"><span class="selected">My store</span><span class="selection">Make this my store</span></button></div><div class="store__show-directions"><a href=" ' +
                    t.getDirectionsUrl(this.location.getPosition()) +
                    '" target=_blank> Show Directions </a></div>' +
                    n +
                    "</div>"
                );
              },
            },
            {
              key: "updateMarker",
              value: function (e, t) {
                e in this.markers && this.markers[e].setIcon(t);
              },
            },
            {
              key: "renderMarkers",
              value: function () {
                var n,
                  r = this;
                this.map &&
                  ((n = new google.maps.LatLngBounds()),
                  this.clearMarkers(),
                  this.currentPageStores.forEach(function (e) {
                    var t = new s.Coordinates(e.latitude, e.longitude),
                      o = new google.maps.Marker({ position: t.getLatLng(), map: r.map, icon: a.MARKERS[r.isSelectedStore(e) ? "selected" : "default"], animation: google.maps.Animation.DROP });
                    (r.markers[e.store_code] = o), n.extend(t.getLatLng());
                  }),
                  this.map.fitBounds(n));
              },
            },
            {
              key: "clearMarkers",
              value: function () {
                for (var e in this.markers) this.markers[e].setMap(null);
                return (this.markers = {}), this.markers;
              },
            },
            {
              key: "updatePagination",
              value: function () {
                var e = (this.currentPage - 1) * this.pageSize + 1,
                  t = Math.min(this.currentPage * this.pageSize, this.stores.length);
                n(".js-results").text("Showing results " + e + " - " + t), n(".c-pagination__arrow--previous").prop("disabled", 1 == e), n(".c-pagination__arrow--next").prop("disabled", t == this.stores.length);
              },
            },
            {
              key: "updateSearchTitle",
              value: function (e, t) {
                t = 1 < arguments.length && void 0 !== t ? t : "";
                n(".c-store-locator__title").attr("data-search-mode", e).attr("data-search-query", t);
              },
            },
            {
              key: "updateMapCenter",
              value: function () {
                this.map.panTo(this.selectedStore.getLatLng());
              },
            },
            {
              key: "selectStore",
              value: function (e) {
                e = this.getStoreByCode(e);
                if (e) return this.selectedStore && this.updateMarker(this.selectedStore.store_code, a.MARKERS.default), (this.selectedStore = e), this.updateMarker(e.store_code, a.MARKERS.selected), this.selectedStore;
              },
            },
            {
              key: "isSelectedStore",
              value: function (e) {
                return this.selectedStore && e.store_code == this.selectedStore.store_code;
              },
            },
            {
              key: "getSelectedStore",
              value: function () {
                return this.selectedStore;
              },
            },
          ],
          [
            {
              key: "MARKERS",
              get: function () {
                return Object.freeze({
                  selected: { url: s.assets.store_locator.primary_marker, scaledSize: new google.maps.Size(34, 34) },
                  default: { url: s.assets.store_locator.secondary_marker, scaledSize: new google.maps.Size(34, 34) },
                });
              },
            },
          ]
        ),
        a
      );
    })();
    s.StoreLocator = e;
  })((window.theme = window.theme || {}), jQuery),
  (function (n) {
    var e = (function () {
      function o() {
        _classCallCheck(this, o), (this.locatePromise = null);
        try {
          var t = JSON.parse(localStorage.getItem(o.STORAGE_KEYS.preferred_store));
          t &&
            n.cart.fetch().then(function (e) {
              e.attributes[o.CART_ATTRIBUTES.pickup_store_code] ||
                (n.cart.updateAttributes((_defineProperty((e = {}), o.CART_ATTRIBUTES.pickup_store_code, t.store_code), _defineProperty(e, o.CART_ATTRIBUTES.shipping_method, null), e)),
                sessionStorage.removeItem(o.STORAGE_KEYS.preferred_shipping));
            });
        } catch (e) {
          console.warn(e);
        }
      }
      return (
        _createClass(
          o,
          [
            {
              key: "getPreferredStore",
              value: function () {
                try {
                  var e = JSON.parse(localStorage.getItem(o.STORAGE_KEYS.preferred_store));
                  return e ? $.when(new n.StoreLocation(e)) : this.locateNearestStore();
                } catch (e) {
                  return console.warn(e), this.locateNearestStore();
                }
              },
            },
            {
              key: "setPreferredStore",
              value: function (e) {
                try {
                  localStorage.setItem(o.STORAGE_KEYS.preferred_store, e);
                } catch (e) {
                  console.error("Customer.setPreferredStore:", e);
                }
                return n.cart.updateAttributes(_defineProperty({}, o.CART_ATTRIBUTES.pickup_store_code, e.store_code)).then(function () {
                  return e;
                });
              },
            },
            {
              key: "locateNearestStore",
              value: function () {
                var t,
                  o = this;
                return (
                  this.locatePromise ||
                    ((t = window.storeLocator || new n.StoreLocator()),
                    (this.locatePromise = n.geolocation
                      .getUserLocation()
                      .then(function (e) {
                        return t.setLocation(e.latitude, e.longitude), t.getStores(e);
                      })
                      .then(function (e) {
                        return o.setPreferredStore(e[0]);
                      }))),
                  this.locatePromise
                );
              },
            },
            {
              key: "getPreferredShipping",
              value: function () {
                var e = JSON.parse(sessionStorage.getItem(o.STORAGE_KEYS.preferred_shipping));
                return $.when(e);
              },
            },
            {
              key: "setPreferredShipping",
              value: function (e) {
                e in o.SHIPPING_KEYS || (e = null);
                try {
                  sessionStorage.setItem(o.STORAGE_KEYS.preferred_shipping, JSON.stringify(e)), sessionStorage.setItem("shipment_flag", "true");
                } catch (e) {
                  console.error(e);
                }
                return n.cart.updateAttributes(_defineProperty({}, o.CART_ATTRIBUTES.shipping_method, e)).then(function () {
                  return n.cart.content.attributes[o.CART_ATTRIBUTES.shipping_method];
                });
              },
            },
            {
              key: "isShipToStore",
              value: function () {
                return this.getPreferredShipping()
                  .then(function (e) {
                    return null !== e
                      ? e
                      : n.cart.content.attributes
                      ? n.cart.content.attributes[o.CART_ATTRIBUTES.shipping_method]
                      : n.cart.fetch().then(function (e) {
                          return e.attributes[o.CART_ATTRIBUTES.shipping_method];
                        });
                  })
                  .then(function (e) {
                    return e === o.SHIPPING_KEYS.ship_to_store;
                  });
              },
            },
          ],
          [
            {
              key: "STORAGE_KEYS",
              get: function () {
                return Object.freeze({ preferred_shipping: "preferred_shipping", preferred_store: "preferred_store" });
              },
            },
            {
              key: "CART_ATTRIBUTES",
              get: function () {
                return Object.freeze({ pickup_store_code: "pickup_store_code", shipping_method: "shipping_method" });
              },
            },
            {
              key: "SHIPPING_KEYS",
              get: function () {
                return Object.freeze({ ship_to_store: "ship_to_store", delivery: "delivery" });
              },
            },
          ]
        ),
        o
      );
    })();
    n.customer = new e();
  })((window.theme = window.theme || {})),
  (function (e, n) {
    var t = (function () {
      function o(e, t) {
        if ((_classCallCheck(this, o), (this.modal = document.getElementById(e)), !this.modal)) return !1;
        (this.defaults = {
          backdrop_fade_in_delay: 500,
          backdrop_fade_out_delay: 1e3,
          backdrop_opacity: 0.68,
          backdrop_selector: ".modal__backdrop",
          close_event: "click",
          close_selector: "[data-modal-close]",
          container_fade_in_delay: 500,
          container_fade_out_delay: 500,
          container_selector: ".modal__container",
          modal_state_open: "modal--open",
        }),
          (this.options = n.extend({}, this.defaults, t || {})),
          (this.backdrop = this.modal.querySelector(this.options.backdrop_selector)),
          (this.container = this.modal.querySelector(this.options.container_selector)),
          (this.closers = this.modal.querySelectorAll(this.options.close_selector)),
          this.bindListeners();
      }
      return (
        _createClass(o, [
          {
            key: "show",
            value: function () {
              n(this.modal).addClass(this.options.modal_state_open),
                n(this.backdrop).fadeTo(this.options.backdrop_fade_in_delay, this.options.backdrop_opacity),
                n(this.container).fadeIn(this.options.container_fade_in_delay),
                n(this.modal).trigger("modal_show");
            },
          },
          {
            key: "hide",
            value: function () {
              n(this.modal).removeClass(this.options.modal_state_open), n(this.backdrop).fadeOut(this.options.backdrop_fade_out_delay), n(this.container).fadeOut(this.options.container_fade_out_delay), n(this.modal).trigger("modal_hide");
            },
          },
          {
            key: "bindListeners",
            value: function () {
              for (var e = this, t = 0; t < this.closers.length; t++)
                n(this.closers[t]).on(this.options.close_event, function () {
                  e.hide();
                });
            },
          },
        ]),
        o
      );
    })();
    e.Modal = t;
  })((window.theme = window.theme || {}), jQuery),
  (function (e, n) {
    var o = (function () {
      function o(e) {
        var t = this;
        _classCallCheck(this, o),
          (this.elements = { $container: e, $trigger: n(".js-dropdown-trigger", e), $close: n(".js-dropdown-close", e), $options: n(".js-dropdown-option", e), $value_indicators: n(".js-dropdown-value", e) }),
          this.elements.$trigger.on("click", this.toggle.bind(this)),
          this.elements.$close.on("click", this.close.bind(this)),
          this.elements.$options.on("click", function (e) {
            t.elements.$value_indicators.text(e.currentTarget.dataset.value), t.close();
          }),
          (this.check_close = function (e) {
            return t.checkClose.call(t, e);
          });
      }
      return (
        _createClass(o, [
          {
            key: "toggle",
            value: function () {
              this.elements.$container.hasClass("is-open") ? this.close() : this.open();
            },
          },
          {
            key: "open",
            value: function () {
              this.elements.$container.addClass("is-open"), n(document).on("click.dropdown", this.check_close);
            },
          },
          {
            key: "close",
            value: function () {
              this.elements.$container.removeClass("is-open"), n(document).off("click.dropdown", this.check_close);
            },
          },
          {
            key: "checkClose",
            value: function (e) {
              e.target === this.elements.$container[0] || n.contains(this.elements.$container[0], e.target) || this.close();
            },
          },
        ]),
        o
      );
    })();
    (e.Dropdown = o),
      n(".js-dropdown").each(function (e, t) {
        return new o(n(t));
      });
  })((window.theme = window.theme || {}), jQuery),
  (function () {
    var t,
      o,
      e = document.querySelector(".js-form-return"),
      n = document.querySelector(".shopify-challenge__container");
    e &&
      ((t = document.querySelector(".contact-form")),
      (e = document.querySelector(".js-form-return-sent")),
      t.addEventListener("submit", function (e) {
        e.preventDefault(), sessionStorage.setItem("returnForm", "submitted"), t.submit();
      }),
      "confirmed" == sessionStorage.getItem("returnForm") && (e.classList.add("form-return__success--active"), sessionStorage.removeItem("returnForm"))),
      n &&
        "submitted" == sessionStorage.getItem("returnForm") &&
        (o = n.querySelector("form")).addEventListener("submit", function (e) {
          e.preventDefault(), grecaptcha.getResponse() && (sessionStorage.setItem("returnForm", "confirmed"), o.submit());
        });
  })(jQuery),
  $("#cart").on("click", ".cart__item--remove", function () {
    var e = $(this).siblings(".cart__item--qty").find("button").data("id");
    $(".nav__cart").addClass("open-on-refresh"), theme.cart.update({ id: e, quantity: 0 });
  }),
  $("#cart").on("click", ".cart__item--qty .js-cart-update", function (e) {
    e.preventDefault();
    var t = $(this).data("id"),
      e = $(this).siblings("input").val();
    return $(".nav__cart").addClass("open-on-refresh"), theme.cart.update({ id: t, quantity: e }), !1;
  }),
  $(document).on("cart_set", function () {
    window.noCartReload ||
      ($(".nav__cart.nav__util--active").addClass("open-on-refresh"),
      $.when(reloadCartLayout(), reloadCartFlyout()).then(function () {
        return theme.cart_inventory.validateInventory();
      }));
  }),
  $("#flyout").on("click", "#cartpage-nosto-5 .product__atc", function (e) {
    "Choose" !== $(this).closest(".nosto-add-to-cart").find(".nosto-select li.selected").text() &&
      setTimeout(function () {
        reloadCartLayout(), reloadCartFlyout();
      }, 500);
  }),
  $(function () {
    var e = window.theme.template;
    "collection" === e.name &&
      -1 < ["list-collections", "brand"].indexOf(e.suffix) &&
      $(".collection__slider-slides").slick({ slidesToShow: 1, autoplay: !0, autoplaySpeed: 2500, slidesToScroll: 1, focusOnSelect: !1, infinite: !0, dots: !1, arrows: !0, draggable: !0 });
  }),
  $(function () {
    $("img[usemap]").on("lazyloaded", function () {
      $(this).rwdImageMaps();
    });
  }),
  $(".image-button-next").on("click", function () {
    $("#image-view").slick("slickNext");
  }),
  $(".image-button-prev").on("click", function () {
    $("#image-view").slick("slickPrev");
  }),
   $(".custom-button-next").on("click", function () {
    $("#image-view").slick("slickNext");
  }),
  $(".custom-button-prev").on("click", function () {
    $("#image-view").slick("slickPrev");
  }),
  $(function () {
    var n = new theme.Modal("modal-shipping-method");
    setTimeout(function () {
      createProductSlider($("#image-controller"), $("#image-view"));
    }, 500),
      $(".product__variants").on("change", "select option, input[type=radio]", function () {
        let var_id = $(this).val();
        $('#selected_variant_id').val(var_id);
        
        updateVariantPrice($(this).val()), $(document).trigger("variant:change");
      }),
      $(".product__variants select option:selected, .product__variants input[type=radio]:checked").trigger("change"),
      $(".product__form").on("submit", function (e) {
        e.preventDefault();
        let bundle_ids = $("#bundle_ids").val();
        bundle_ids = bundle_ids.split(",");
        for (var i = 0; i < bundle_ids.length; i++) {
          if (bundle_ids[i] == "") {
            bundle_ids.splice(i, 1);
          }
        }
        var t = localStorage.getItem("edit_id"),
          o = $(this).serialize(),
          e = $.when();
        -1 < window.location.href.indexOf("fromCart") &&
          ((window.noCartReload = !0),
          (e = e
            .then(function () {
              if (bundle_ids.length > 0) {
                for (var i = 0; i < bundle_ids.length; i++) {
                  theme.cart.update({ id: bundle_ids[i], quantity: 0 }, "remove");
                }
              } else {
                return theme.cart.update({ id: t, quantity: 0 }, "remove");
              }
            })
            .always(function () {
              return (window.noCartReload = !1);
            }))),
          e
            .then(function () {

              //selected variant id
              let var_id = $("#selected_variant_id").val();
      
              let bundle_product_ids =[];
              let bundle_p_ids = $('#bundle_product_ids').val();
              if(bundle_p_ids != "")
              {
                bundle_product_ids = bundle_p_ids.split(",");
              }
              if(bundle_product_ids.length > 0)
              {
                let get_size_val = "";
                let get_color_val = "";
                let size_option_index = 0;
                let color_option_index = 0;
                //get variant of main product
                let main_p_handle = $('#mainp').val() + ".js";
                let main_p_url = window.Shopify.routes.root + 'products/'+ main_p_handle;
                 let skus = [];
                let b_skus = "";
                $.ajax({ url: main_p_url,type: "GET", dataType: "json", async:false })
                .done(function (e) {
                  //console.log(e);
                })
                .fail(function (e) {
                  console.log(e);
                })
                .then(function(e){
                    // get selected variant data
                    for(var i=0;i<e.options.length;i++)
                    {
                      if(e.options[i]["name"].toLowerCase() == "size")
                      {
                        size_option_index = i+1;
                      }
                      if(e.options[i]["name"].toLowerCase() == "color" || e.options[i]["name"].toLowerCase() == "colour") 
                      {
                        color_option_index = i+1;
                      }
                    }
          
                    for(var i = 0; i< e.variants.length;i++)
                    {
                       if(var_id == e.variants[i]["id"])
                       {
                         if(size_option_index > 0)
                         {
                           get_size_val = e.variants[i]["option"+size_option_index]; 
                         }
          
                         if(color_option_index > 0)
                         {
                           get_color_val = e.variants[i]["option"+color_option_index];
                         }
                       }
                    }
                    //updateBundleSkus(bundle_product_ids,get_size_val,get_color_val);
                    return addBundleItemToCart(bundle_product_ids,get_size_val,get_color_val,var_id);
                    
                });
              }
              else {
                return $.ajax({ url: "/cart/add.js", data: o, type: "POST", dataType: "json" })
                  .done(function () {
                    $(".nav__cart").addClass("open-on-refresh"),
                      $(".product__cart-error").empty(),
                      -1 < window.location.href.indexOf("fromCart") && ($(".js-flyout-overlay").removeClass("flyout__overlay--active"), $(document.body).removeClass("scroll-hidden"));
                  })
                  .fail(function (e) {
                    422 == e.status && ((e = e.responseJSON), $(".product__cart-error").text(e.description));
                  });
              }
              // if (bundle_ids.length > 0) {
              //   let d_items = [];
              //   for (var i = 0; i < bundle_ids.length; i++) {
              //     let d_item = { id: bundle_ids[i], quantity: 1 };
              //     d_items.push(d_item);
              //   }
              //   let data_items = { items: d_items };
              //   $.ajax({ url: "/cart/add.js", data: data_items, type: "POST", dataType: "json" })
              //     .done(function () {
              //       $(".nav__cart").addClass("open-on-refresh"),
              //         $(".product__cart-error").empty(),
              //         -1 < window.location.href.indexOf("fromCart") && ($(".js-flyout-overlay").removeClass("flyout__overlay--active"), $(document.body).removeClass("scroll-hidden"));
              //     })
              //     .fail(function (e) {
              //       422 == e.status && ((e = e.responseJSON), $(".product__cart-error").text(e.description));
              //     });
              // } else {
              //   return $.ajax({ url: "/cart/add.js", data: o, type: "POST", dataType: "json" })
              //     .done(function () {
              //       $(".nav__cart").addClass("open-on-refresh"),
              //         $(".product__cart-error").empty(),
              //         -1 < window.location.href.indexOf("fromCart") && ($(".js-flyout-overlay").removeClass("flyout__overlay--active"), $(document.body).removeClass("scroll-hidden"));
              //     })
              //     .fail(function (e) {
              //       422 == e.status && ((e = e.responseJSON), $(".product__cart-error").text(e.description));
              //     });
              // }
              // return $.ajax({ url: "/cart/add.js", data: o, type: "POST", dataType: "json" })
              //     .done(function () {
              //       $(".nav__cart").addClass("open-on-refresh"),
              //         $(".product__cart-error").empty(),
              //         -1 < window.location.href.indexOf("fromCart") && ($(".js-flyout-overlay").removeClass("flyout__overlay--active"), $(document.body).removeClass("scroll-hidden"));
              //     })
              //     .fail(function (e) {
              //       422 == e.status && ((e = e.responseJSON), $(".product__cart-error").text(e.description));
              //     });
            })
            .then(function () {
              return triggerShipmentModal(n).fail(function () {
                return theme.cart.fetch();
              });
            });
      }),
      createCardSlider(".featured-products__recommended--product"),
      $(window).resize(function () {
        createCardSlider(".featured-products__product-tiles"), createCardSlider(".featured-products__recommended--product");
      }),
      -1 < window.location.href.indexOf("fromCart") && ($(".product__atc").text("Update Cart"), $(".product__quantity-container input").val(localStorage.getItem("edit_qty"))),
      $(document).on("cart_fetch cart_update", function (e, t) {
        $(".nav__cart .cart__count").text(t.item_count), updateFreeShipping(t.total_price / 100);
      }),
      document.getElementById("store-locator_modal") &&
        ((theme.store_locator_modal = new theme.Modal("store-locator_modal")),
        $(".js-open-store-locator-modal").click(function () {
          theme.store_locator_modal.show();
        })),
      setTimeout(function () {
        var e = document.querySelector(".best-fit-size-chart button");
        -1 < window.location.href.indexOf("/fr/") &&
          e &&
          e.addEventListener("click", function () {
            setTimeout(function () {
              document.querySelector(".bottom-description").hidden = !0;
            }, 100);
          });
      }, 5e3);
  }),
  $(function () {
    var t,
      o,
      n,
      r = "header__nav",
      a = "nav__item",
      s = "nav__item-child",
      i = ".nav__list",
      c = ".nav__list-child",
      l = ".nav__list-grandchild";
    function e() {
      var e = t.is(":visible") ? t.outerHeight() : 0;
      o.css("top", "".concat(e, "px")), $(".nav").css("top", "".concat(e + n.outerHeight(), "px"));
    }
    (t = $(".banner--top")),
      (o = $("#header")),
      (n = $(".header__logo")),
      e(),
      t.length &&
        (e(),
        $(window).on("resize", function () {
          e();
        })),
      $("#header").on("click", ".header__nav, .nav__item, .nav__item-child", function (e) {
        var t, o;
        e.stopPropagation(),
          (0 < $(this).find(".nav__list-child").length || 0 < $(this).find(".nav__list-grandchild").length) &&
            ((t = $(this)).hasClass(r)
              ? ((e = t.find(i)).toggleClass("menu__open"),
                e.hasClass("menu__open")
                  ? ($("html, body").addClass("scroll_lock"),
                    $(".nav").addClass("nav__open"),
                    $(".nav__close-button").addClass("nav__open"),
                    $(".flyout--open").removeClass("flyout--open"),
                    $(".flyout__overlay--active").removeClass("flyout__overlay--active"),
                    $(document.body).removeClass("scroll-hidden"))
                  : (e.find(".menu__open").removeClass("menu__open"),
                    t.find(".fa-chevron-right").removeClass("fa-rotate-90"),
                    $("html, body").removeClass("scroll_lock"),
                    $(".nav").removeClass("nav__open"),
                    $(".nav__close-button").removeClass("nav__open")))
              : t.hasClass(a)
              ? ((o = t.find(c)).toggleClass("menu__open"),
                o.hasClass("menu__open")
                  ? t.children(".menu_toggle-primary").find(".fa-chevron-right").addClass("fa-rotate-90")
                  : (o.find(".menu__open").removeClass("menu__open"), o.find(".fa-chevron-right").removeClass("fa-rotate-90"), t.find(".fa-chevron-right").removeClass("fa-rotate-90")))
              : t.hasClass(s) && ((o = t.find(l)).toggleClass("menu__open"), o.hasClass("menu__open") ? t.find(".fa-chevron-right").addClass("fa-rotate-90") : t.find(".fa-chevron-right").removeClass("fa-rotate-90")));
      }),
      $("#header").on("click", ".nav__util, .js-close-flyout", function () {
        toggleFlyout($(this));
      }),
      $("#flyout").on("click", ".js-product-qty-box .js-qty-btn", function () {
        var e = $(this).closest(".js-product-qty").find(".js-flyout-update").data("id"),
          t = parseInt($(this).closest(".js-product-qty").find(".js-product-qty-input").attr("max")),
          o = parseInt($(this).closest(".js-product-qty").find(".js-product-qty-input").val()),
          n = parseInt($(this).parent(".js-product-qty-box").find(".js-product-qty-input").val());
        $(this).hasClass("js-qty-plus") ? (n++, (o += 1)) : 1 < n && (n--, --o),
          (n = isNaN(n) ? 1 : n),
          $(this).parent(".js-product-qty-box").find(".js-product-qty-input").val(n),
          theme.cart.update({ id: e, quantity: n }).then(function (e) {
            o === t ? $(".js-qty-plus").attr("disabled", !0) : 1 === o ? $(".js-qty-minus").attr("disabled", !0) : ($(".js-qty-minus").attr("disabled", !1), $(".js-qty-plus").attr("disabled", !1));
          });
      }),
      $("#flyout").on("click", ".line-item__qty .js-flyout-update", function () {
        var o = $(this).data("id"),
          e = $(this).siblings("input"),
          n = e.val(),
          t = parseInt(e.attr("max"));
        t && t < n && ((n = t), e.val(t)),
          theme.cart.update({ id: o, quantity: n }).then(function (e) {
            var t = theme.utils.toMoney(e.total_price, { cents: !0 });
            $(".nav__cart .cart__count").text(e.item_count), $(".flyout__footer__total .subtotal--money").text(t), 0 == n && removeLineItem(o);
          });
      }),
      $("#flyout").on("click", ".line-item__qty .line-item__qty--remove", function (e) {
        e.preventDefault();
        if($(this).hasClass("bundle-item"))
        {
          
          let bundle_var_id = $(this).attr('data-bundle-selected-id');
          let selector_val = 'span[data-bundle-selected-id="' + bundle_var_id + '"]';
          let vids = [];
          $(selector_val).each(function(){
            let vid = $(this).attr('data-vid');
             vids.push({id:vid,quantity:0});
          });
          theme.cart.update(vids);
        }
        else  
        {
          e = $(this).closest(".js-product-qty").find(".js-flyout-update").data("id");
          $(this).closest(".line-item").remove(), removeLineItem(e);  
        }
        
      }),
      $("#flyout").on("input", ".js-product-qty-input", function () {
        $(this).siblings("button").addClass("button--active");
      }),
      $(document).mouseup(function (e) {
        var t = $("#flyout .js-product-qty-input");
        t.is(e.target) || 0 !== t.has(e.target).length || t.siblings("button").removeClass("button--active");
      }),
      $("#flyout").on("click", ".line-item__edit-link", function (e) {
        e.preventDefault();
        var t = $(this).closest(".line-item__edit-link").data("prodUrl"),
          o = $(this).closest(".js-product-qty").find(".js-flyout-update").data("id"),
          e = $(this).closest(".js-product-qty").find(".js-product-qty-input").val();
        localStorage.setItem("edit_id", o), localStorage.setItem("edit_qty", e), (window.location.href = t + "?fromCart=true");
      }),
      $(".search__input").removeAttr("role");
    function u(e) {
      e.classList.remove("active"), (h.activeIndex = -1);
    }
    var d = document.querySelectorAll(".nav__item"),
      h = { activeIndex: -1 };
    d.forEach(function (t, o) {
      t.addEventListener("keydown", function (e) {
        32 === e.keyCode && (e.preventDefault(), t.classList.contains("active") ? u(t) : (-1 !== h.activeIndex && u(d[h.activeIndex]), (e = o), t.classList.add("active"), (h.activeIndex = e)));
      });
    }),
      $("#header").on("click", ".nav__close-button", function (e) {
        e.stopPropagation(),
          $(".nav__close-button").removeClass("nav__open"),
          $(".nav").removeClass("nav__open"),
          $(".header__nav").find(".menu__open").removeClass("menu__open"),
          $(".header__nav").find(".fa-chevron-right").removeClass("fa-rotate-90"),
          $("html, body").removeClass("scroll_lock");
      });
  }),
  $(function () {
    $(".footer-list__link.footer-list__link__1").on("click", function (e) {
      e.preventDefault(), $(this).parent().toggleClass("footer-list__li__1--active");
    }),
      -1 < window.location.href.indexOf("/fr/") &&
        $(document).on("click", ".footer-list__link", function (e) {
          e.preventDefault();
          e = $(this).attr("href");
          window.location.href = e.replace("boathousestores.com", "boathousestores.com/fr");
        });
  }),
  $(".product-tile").on("click", ".product-tile__quickview-link", function (e) {
    e.preventDefault(),
      $(".quickview").load($(this).closest(".product-tile").find(".product-tile__quickview-link").data("href"), function () {
        createProductSlider($(".quickview").find("#image-controller"), $(".quickview").find("#image-view")),
          $(".product__variants select option:selected, .product__variants input[type=radio]:checked").trigger("change"),
          $(".product__form").on("submit", function (e) {
            e.preventDefault();
            let bundle_ids = $("#bundle_ids").val();
            bundle_ids = bundle_ids.split(",");
            for (var i = 0; i < bundle_ids.length; i++) {
              if (bundle_ids[i] == "") {
                bundle_ids.splice(i, 1);
              }
            }
            e = localStorage.getItem("edit_id");
            -1 < window.location.href.indexOf("fromCart")
              ? theme.cart.update({ id: e, quantity: 0 }).then(function () {
                  return addToCart($(".product__form").find(".product__variants"), ".product__variants-option", $(".product__form").find(".product__quantity"));
                })
              : (addToCart($(this).find(".product__variants"), ".product__variants-option", $(this).find(".product__quantity")), $(".quickview").removeClass("quickview--active"));
          });
      }),
      $(".quickview").addClass("quickview--active");
  }),
  $(document).on("click", ".quickview__background", function (e) {
    $(".quickview").removeClass("quickview--active");
  }),
  $(function () {
    "index" == window.theme.template.name &&
      ($(".homepage__slider").slick({ slidesToShow: 1, slidesToScroll: 1, focusOnSelect: !1, infinite: !0, dots: !0, arrows: !1, draggable: !0 }),
      $(".js-brand-showcase-list").slick({
        infinite: !1,
        speed: 300,
        slidesToShow: 9,
        slidesToScroll: 1,
        swipeToSlide: !0,
        responsive: [
          { breakpoint: 1024, settings: { slidesToShow: 7 } },
          { breakpoint: 992, settings: { slidesToShow: 5 } },
          { breakpoint: 640, settings: { slidesToShow: 5 } },
        ],
      }));
  }),
  $(function () {
    $(".account-nav__link").on("click", function () {
      $(this).toggleClass("account-nav__link--active");
    }),
      -1 < window.location.href.indexOf("/fr/") &&
        ($(document).on("click", ".account-nav__link-name", function (e) {
          e.preventDefault();
          e = $(this).attr("href");
          window.location.href = e.replace("boathousestores.com", "boathousestores.com/fr");
        }),
        document.querySelectorAll(".account-nav__list-item").forEach(function (e) {
          e = e.querySelector('.account-nav__link-name[href*="gift"]');
          e && e.parentElement.remove();
        }));
  }),
  $(function () {
    $(".addresses__add-new-address").on("click", function (e) {
      e.preventDefault(), $(".addresses__main-container").hasClass("hide-form") && ($(".addresses__main-container").removeClass("hide-form"), $(".addresses__addresses-listing").addClass("hide-listing"));
    });
  }),
  $(function () {
    $(".edit-address")
      .first()
      .each(function () {
        var e = window.location.href,
          t = theme.utils.getURLParams(e).address,
          e = "#edit_address_".concat(t),
          e = $(".edit-address").find(e);
        e.data("addressId") == t && e.addClass("addresses__edit-address-form-container--show"), history.pushState({}, "", "/account/addresses");
      });
  }),
  $(function () {
    $(".brands__list-container__sublist-title").on("click", function (e) {
      e.preventDefault(), $(this).parent().find(".brands__list-container__sublist").toggleClass("brands__list-container__sublist--active"), $(this).toggleClass("brands__list-container__sublist-title--active");
    });
  }),
  $(function () {
    var t = $(".js-tooltip"),
      e = $(".js-tooltip-open"),
      o = $(".js-tooltip-close");
    e.on("click", function (e) {
      $(this).closest(t).toggleClass("is-active");
    }),
      o.on("click", function (e) {
        $(this).closest(t).removeClass("is-active");
      }),
      $(document).on("click", function (e) {
        0 == $(e.target).closest(".js-tooltip").length && $(".js-tooltip").removeClass("is-active");
      });
  }),
  (function (n, e) {
    (n.loadStoreLabels = function () {
      n.customer.getPreferredStore().then(function (o) {
        e("[data-store-location]").each(function () {
          var e = this.dataset.storeLocation,
            t = n.locales;
          switch (e) {
            case "directions_url":
              this.href = o.getDirectionsUrl();
              break;
            case "open":
              (this.dataset.storeState = 1 == o[e] ? "".concat(t.shipment_method.store_state.open) : "".concat(t.shipment_method.store_state.close)),
                (this.textContent = o.today_hours ? " ".concat(t.shipment_method.store_state.open_text, " ").concat(o.today_hours.open_time) : "");
              break;
            case "open_hours":
              this.innerHTML = o.getHours().reduce(function (e, t) {
                return (e += '<p class="schedule__time">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="schedule__day" data-store-day="'
                  .concat(t.day, '"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="schedule__hours" data-store-open-time="')
                  .concat(t.open_time, '" data-store-close-time="')
                  .concat(t.close_time, '"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</p>'));
              }, "");
              break;
            case "address_area":
              this.textContent = o.address_city + ", " + o.address_province_code + " " + o.address_postal_code;
              break;
            default:
              this.textContent = o[e];
          }
        });
      });
    }),
      e(function () {
        n.loadStoreLabels(),
          e(document).on("store_change", function () {
            n.loadStoreLabels();
          });
      });
  })((window.theme = window.theme || {}), jQuery),
  (function (c, l) {
    var e = (function () {
        function e() {
          _classCallCheck(this, e), (this.states = { statusAvailable: "status--available", statusUnavailable: "status--unavailable" }), (this.cache = {}), (this.inventoryParams = [{ key: "store_code", value: this.getStoreId }]);
        }
        return (
          _createClass(e, [
            {
              key: "getStoreId",
              value: function () {
                return c.customer.getPreferredStore().then(function (e) {
                  return e.store_code;
                });
              },
            },
            {
              key: "loadInventoryData",
              value: function (e, t) {
                var o = JSON.stringify(t);
                return o in this.cache || (this.cache[o] = l.get(e, t).then(this.parseInventoryData)), this.cache[o];
              },
            },
            {
              key: "parseInventoryData",
              value: function (e) {
                return (
                  "variants" in e &&
                    (e = e.variants.reduce(function (e, t) {
                      return (e[t.sku] = t), e;
                    }, {})),
                  e
                );
              },
            },
            {
              key: "getInventory",
              value: function () {
                var n = this;
                return l.when
                  .apply(
                    l,
                    this.inventoryParams.map(function (e) {
                      return e.value.call(n);
                    })
                  )
                  .then(function () {
                    for (var e = arguments.length, t = new Array(e), o = 0; o < e; o++) t[o] = arguments[o];
                    return t.reduce(function (e, t, o) {
                      return (e[n.inventoryParams[o].key] = t), e;
                    }, {});
                  })
                  .then(function (e) {
                    return n.loadInventoryData(n.endpoint, e);
                  });
              },
            },
            {
              key: "getSku",
              value: function (e) {
                return e.dataset.variantSku;
              },
            },
            {
              key: "isAvailable",
              value: function (t, e) {
                var o = 1 < arguments.length && void 0 !== e ? e : 1;
                return this.getInventory().then(function (e) {
                  return t in e && e[t].quantity >= o;
                });
              },
            },
            {
              key: "checkAvailability",
              value: function (e, t, o) {
                var n = this;
                return this.isAvailable(this.getSku(e), o).done(function (e) {
                  return n.setAvailabilityState(t, e);
                });
              },
            },
            {
              key: "setAvailabilityState",
              value: function (e, t) {
                l(e).toggleClass(this.states.statusAvailable, t), l(e).toggleClass(this.states.statusUnavailable, !t);
              },
            },
          ]),
          e
        );
      })(),
      t = (function () {
        _inherits(n, e);
        var o = _createSuper(n);
        function n(e) {
          var t;
          return (
            _classCallCheck(this, n),
            ((t = o.call(this)).productElement = e),
            (t.endpoint = "/apps/integrations-api/v1/product_availability"),
            (t.selectors = { productForm: "#product-form-" + t.getProductId(), variantInput: "[data-variant-sku]", availabilityStatus: ".js-product-availability" }),
            t.inventoryParams.push({ key: "product_id", value: t.getProductId }),
            l(t.selectors.productForm).on("change", t.selectors.variantInput, function (e) {
              t.checkAvailability(e.target, t.selectors.availabilityStatus, 1);
            }),
            t.refreshAvailability(),
            t
          );
        }
        return (
          _createClass(n, [
            {
              key: "refreshAvailability",
              value: function () {
                var t = this;
                l(this.selectors.productForm)
                  .find(this.selectors.variantInput)
                  .filter(":checked")
                  .get()
                  .forEach(function (e) {
                    t.checkAvailability(e, t.selectors.availabilityStatus, 1);
                  });
              },
            },
            {
              key: "getProductId",
              value: function () {
                return this.productElement.dataset.productStoreInventory;
              },
            },
          ]),
          n
        );
      })(),
      o = (function () {
        _inherits(n, e);
        var o = _createSuper(n);
        function n(e) {
          var t;
          return (
            _classCallCheck(this, n),
            ((t = o.call(this)).$container = e),
            (t.selectors = { warnings: ".js-cart-flyout-warning", items: ".js-item-pickup-warning", notices: ".js-cart-flyout-notice" }),
            (t.endpoint = "/apps/integrations-api/v1/item_availability"),
            t.inventoryParams.push({ key: "skus", value: t.getCartSkus }),
            t.validateInventory(),
            t
          );
        }
        return (
          _createClass(n, [
            {
              key: "validateInventory",
              value: function () {
                var i = this;
                l.when
                  .apply(
                    l,
                    l(this.selectors.items, this.$container)
                      .get()
                      .map(function (e) {
                        return i.checkAvailability(e, e, e.dataset.quantity);
                      })
                  )
                  .then(
                    _asyncToGenerator(
                      regeneratorRuntime.mark(function e() {
                        var t,
                          o,
                          n,
                          r,
                          a,
                          s = arguments;
                        return regeneratorRuntime.wrap(function (e) {
                          for (;;)
                            switch ((e.prev = e.next)) {
                              case 0:
                                return (e.next = 2), c.customer.isShipToStore();
                              case 2:
                                for (t = e.sent, o = s.length, n = new Array(o), r = 0; r < o; r++) n[r] = s[r];
                                (a = n.every(function (e) {
                                  return e;
                                })),
                                  i.setAvailabilityState(l(i.selectors.warnings, i.$container), a || !t),
                                  i.setAvailabilityState(l(i.selectors.notices, i.$container), a && !t);
                              case 7:
                              case "end":
                                return e.stop();
                            }
                        }, e);
                      })
                    )
                  );
              },
            },
            {
              key: "getCartSkus",
              value: function () {
                return (c.cart.content.items ? l.when(c.cart.content) : c.cart.fetch()).then(function (e) {
                  return e.items.map(function (e) {
                    return e.sku;
                  });
                });
              },
            },
            {
              key: "getCartQuantities",
              value: function () {
                return (c.cart.content.items ? l.when(c.cart.content) : c.cart.fetch()).then(function (e) {
                  return e.items.reduce(function (e, t) {
                    return (e[t.sku] = t.quantity + (e[t.sku] || 0)), e;
                  }, {});
                });
              },
            },
            {
              key: "checkAvailability",
              value: function (e, n, t) {
                var r = this;
                return this.isAvailable(this.getSku(e), t).done(
                  (function () {
                    var t = _asyncToGenerator(
                      regeneratorRuntime.mark(function e(t) {
                        var o;
                        return regeneratorRuntime.wrap(function (e) {
                          for (;;)
                            switch ((e.prev = e.next)) {
                              case 0:
                                return (e.next = 2), c.customer.isShipToStore();
                              case 2:
                                (o = e.sent), r.setAvailabilityState(n, t || !o);
                              case 4:
                              case "end":
                                return e.stop();
                            }
                        }, e);
                      })
                    );
                    return function (e) {
                      return t.apply(this, arguments);
                    };
                  })()
                );
              },
            },
          ]),
          n
        );
      })();
    l(function () {
      var e = document.querySelector("[data-product-store-inventory]");
      e &&
        ((c.productStoreInventory = new t(e)),
        l(document).on("store_change", function () {
          c.productStoreInventory.refreshAvailability();
        })),
        (c.cart_inventory = new o(l(".js-cart-item-inventory")));
    });
  })((theme = window.theme || {}), jQuery),
  (function (a) {
    var o,
      e = document.querySelector("#store-locator-form");
    function t(e) {
      var t = o.getSelectedStore();
      t && a("#" + t.store_code).removeClass("store--selected");
      e = o.selectStore(e);
      e && a("#" + e.store_code).addClass("store--selected");
    }
    e &&
      ((o = new theme.StoreLocator(e)),
      (window.storeLocator = o),
      theme.geolocation
        .getUserLocation()
        .done(function (e) {
          return o.setLocation(e.latitude, e.longitude);
        })
        .always(function () {
          a.when(theme.customer.getPreferredStore(), o.getStores()).then(function (e) {
            return t(e.store_code);
          });
        }),
      a(".js-showmap-text").removeClass("c-store-locator__showmap__text--show"),
      a(".js-showmap").on("click", function () {
        a(this).toggleClass("c-store-locator__showmap--active"), a(".c-store-locator__map").toggleClass("c-store-locator__map--hide"), a(".c-store-locator__map").hasClass("c-store-locator__map--hide") || o.renderMarkers();
      }),
      a(document).on("click.store", ".js-show-hours", function () {
        a(this).closest(".store").toggleClass("store--show-hours");
      }),
      a(document).on("click.store", ".js-store:not(.store--selected) [data-store-code]", function () {
        a.when(
          this.dataset.storeCode,
          (function (e) {
            if (0 == theme.cart.content.item_count || !theme.customer.isShipToStore() || !e) return a.when();
            var t,
              o,
              n = a.Deferred(),
              r = a("#" + e);
            return (
              0 < r.length &&
                ((t = r.find(".js-confirm-store-change")),
                (o = new theme.Modal(e)).show(),
                t.off("click").on("click", function () {
                  n.resolve(), o.hide();
                }),
                r.off("modal_hide").on("modal_hide", function () {
                  n.reject();
                })),
              n.promise()
            );
          })("store_change_modal_id")
        ).then(function (e) {
          theme.customer.setPreferredStore(o.getStoreByCode(e)).then(function (e) {
            t(e.store_code), o.updateMapCenter(), a(document).trigger("store_change");
          });
        });
      }));
  })(jQuery),
  (function (o, n) {
    function r(e) {
      _classCallCheck(this, r),
        (this.elements = { $container: e, $selectors: n(".js-update-shipping", e) }),
        this.elements.$selectors.on("click", function (e) {
          var t = e.currentTarget.dataset.shippingMethod;
          t !== o.customer.constructor.SHIPPING_KEYS.delivery
            ? o.customer.getPreferredStore().then(
                function () {
                  o.customer.setPreferredShipping(t);
                },
                function () {
                  o.store_locator_modal.show(),
                    n(document).one("store_change", function () {
                      o.customer.setPreferredShipping(t);
                    });
                }
              )
            : o.customer.setPreferredShipping(t);
        }),
        o.loadStoreLabels(this.elements.$container);
    }
    (o.ShippingMethodChooser = r),
      n(function () {
        n(".js-shipping-method-selector").each(function (e, t) {
          return new r(n(t));
        });
      });
  })((window.theme = window.theme || {}), jQuery),
  (function (t) {
    var e = t('[name="shipping-method"]'),
      o = t("[data-shipping]"),
      n = t("[data-show-schedule]"),
      r = t(".js-shipment-confirm"),
      a = t(".js-shipment-alert"),
      s = t(".js-toggle-alert");
    n.on("click", function () {
      t("[data-scheduled-hours]").toggleClass("shipment__schedule--show");
    }),
      s.on("click", function (e) {
        r.hasClass("shipment__submit-button--disabled") && (e.preventDefault(), a.addClass("shipment__alert--active"));
      }),
      t(document).on("store_change modal_show", function () {
        t("[data-scheduled-hours]").children().length ? t("[data-show-schedule]").removeClass("my-store__hours--hide") : t("[data-show-schedule]").addClass("my-store__hours--hide");
      }),
      e.on("change", function () {
        var e = t(this).attr("id");
        o.removeClass("is-selected"), t('label[for="'.concat(e, '"]')).addClass("is-selected"), r.removeClass("shipment__submit-button--disabled"), a.removeClass("shipment__alert--active");
      }),
      t(function () {
        t("[data-scheduled-hours]").children().length ? t("[data-show-schedule]").removeClass("my-store__hours--hide") : t("[data-show-schedule]").addClass("my-store__hours--hide");
      });
  })(((theme = window.theme || {}), jQuery)),
  (function (e, i) {
    var c, l, u, d, h;
    "product" == e.template.name &&
      ((c = e.product.tags),
      (l = 0),
      (h = d = u = ""),
      i(".product__identifier-discounts").each(function () {
        var e = i(this).attr("data-flag"),
          t = i(this).attr("data-percentage-off-dis"),
          o = i(this).attr("data-discount-message"),
          n = i(this).attr("data-bg-color"),
          r = i(this).attr("data-font-color");
        if ("tag" == e) for (var a = (a = i(this).attr("data-product-identifiers")).split(","), s = 0; s < a.length; s++) c.includes(a[s]) && l <= t && ((l = t), (u = o), (d = n), (h = r));
      }),
      0 <= l && (i(".promo-product-image").html(u), i(".promo-product-image").css("background", d), i(".promo-product-image").css("color", h)));
  })((window.theme = window.theme || {}), window.jQuery),
  (function (e) {
    "product" == e.template.name && (window.brontoBrowseObject = { product: e.product });
  })((window.theme = window.theme || {})),
  (function (a) {
    var s = ["//staticxx.s3.amazonaws.com/aio_stats_lib_v1.min.js?v=1.0"];
    setTimeout(function () {
      var t, e, o, n, r;
      s.forEach(function (e) {
        a.ajax({ url: e, dataType: "script", async: !0 });
      }),
        (t = window),
        (e = document),
        (t[(o = "uetq")] = t[o] || []),
        (n = function () {
          var e = { ti: "25021800" };
          (e.q = t[o]), (t[o] = new UET(e)), t[o].push("pageLoad");
        }),
        ((r = e.createElement("script")).src = "//bat.bing.com/bat.js"),
        (r.async = 1),
        (r.onload = r.onreadystatechange = function () {
          var e = this.readyState;
          (e && "loaded" !== e && "complete" !== e) || (n(), (r.onload = r.onreadystatechange = null));
        }),
        (e = e.getElementsByTagName("script")[0]).parentNode.insertBefore(r, e);
    }, 5e3);
  })(window.jQuery),
  $(function () {
    function t(e) {
      e.target.form.submit();
    }
    document.querySelectorAll(".shopify-localization-form select").forEach(function (e) {
      e.addEventListener("change", t);
    });
  }),
  $(function () {
    var r;
    -1 < window.location.href.indexOf(".com/fr") &&
      ((r = window.theme.locales),
      $(document).on("click", ".nosto_carousel a", function (e) {
        e.preventDefault();
        e = $(this).attr("href");
        window.location.href = e.replace("boathousestores.com", "boathousestores.com/fr");
      }),
      setTimeout(function () {
        document.querySelectorAll(".nosto_carousel").forEach(function (e) {
          e.querySelectorAll(".product-tile").forEach(function (e) {
            var t = e.querySelector(".product-tile__title"),
              o = e.querySelector("a").href,
              n = _slicedToArray(new RegExp(/\/products\/([\w|-]+)/).exec(o), 2)[1],
              o = e.querySelector(".product__atc"),
              e = e.querySelector(".option-item:first-child");
            fetch("/fr/products/".concat(n, ".js"))
              .then(function (e) {
                return e.json();
              })
              .then(function (e) {
                t.textContent = e.title;
              })
              .catch(function (e) {
                console.warn("ShopifyProductFetch - Product title", e);
              }),
              r.product && (r.product.add_to_cart && (o.innerHTML = r.product.add_to_cart), r.product.variant_selection && (e.innerHTML = r.product.variant_selection));
          });
        });
      }, 2e3));
  }),
  (function (n) {
    function e() {
      var e,
        t,
        o = window.badges_array;
      o &&
        n.product &&
        0 <
          (t = o.filter(function (e) {
            return n.product.tags.includes(e.tag);
          })).length &&
        ((e = t[0]), (o = document.querySelector(".image__gallery")), (t = document.createElement("DIV")).classList.add("product-badge"), (t.innerHTML = '<img src="'.concat(e.image, '" alt="').concat(e.title, '" />')), o.append(t));
    }
    document.addEventListener("shopify:section:load", e), window.addEventListener("load", e);
  })(window.theme || {}),
  (function (e, i) {
    var c = e.locales;
    function t() {
      var t,
        a = i(".js-banner-carousel"),
        s = i(".banner"),
        o = i("body"),
        e = i(".js-banner-play"),
        n = i(".js-banner-pause"),
        r = 1e3 * parseInt(a.data("autoplay-speed") || 5);
      a.on("beforeChange", function (e, t, o, n) {
        var r = a.find('[data-slick-index="'.concat(n, '"]')),
          n = r.data("text-color"),
          r = r.data("bg-color");
        s.css("--text-color", n).css("--bg-color", r);
      }),
        a.on("init", function () {
          n.show();
        }),
        n.on("click", function () {
          a.slick("slickPause"), n.hide(), e.show();
        }),
        e.on("click", function () {
          a.slick("slickPlay"), e.hide(), n.show();
        }),
        s.data("fixed") ||
          ((t = window.scrollY),
          i(window).on("scroll", function () {
            var e = window.scrollY;
            e < t ? o.hasClass("has-hidden-banner") && (o.removeClass("has-hidden-banner"), i(window).trigger("resize")) : o.hasClass("has-hidden-banner") || (o.addClass("has-hidden-banner"), i(window).trigger("resize")), (t = e);
          })),
        a.slick({
          autoplay: !0,
          autoplaySpeed: r,
          infinite: !0,
          prevArrow: '\n        <button type="button" class="slick-prev" title="'.concat(
            c.carousel.previous,
            '">\n          <svg xmlns="http://www.w3.org/2000/svg" width="5" height="10" viewBox="0 0 7 12"><path d="M6,0a1,1,0,0,1,.71.29,1,1,0,0,1,0,1.42L2.41,6l4.3,4.29a1,1,0,1,1-1.42,1.42l-5-5a1,1,0,0,1,0-1.42l5-5A1,1,0,0,1,6,0Z" /></svg>\n        </button>\n      '
          ),
          nextArrow: '\n        <button type="button" class="slick-next" title="'.concat(
            c.carousel.next,
            '">\n          <svg xmlns="http://www.w3.org/2000/svg" width="5" height="10" viewBox="0 0 7 12"><path d="M1,12a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.42L4.59,6,.29,1.71A1,1,0,0,1,1.71.29l5,5a1,1,0,0,1,0,1.42l-5,5A1,1,0,0,1,1,12Z" /></svg>\n        </button>\n      '
          ),
          responsive: [{ breakpoint: 640, settings: { autoplay: !1 } }],
        });
    }
    document.addEventListener("shopify:section:load", t), window.addEventListener("load", t);
  })(window.theme || {}, window.jQuery),
  (function () {
    var e = document.querySelectorAll(".js-product-accordion-heading"),
      n = [];
    e.forEach(function (e) {
      var t = e.querySelector("button");
      n.push(t);
      var o = e.nextElementSibling;
      t.onclick = function () {
        var e;
        "true" === t.getAttribute("aria-expanded")
          ? ((e = o), t.setAttribute("aria-expanded", !1), e.classList.remove("is-open"), (e.style.maxHeight = 0))
          : ((e = o), t.setAttribute("aria-expanded", !0), e.classList.add("is-open"), (e.style.maxHeight = e.scrollHeight + "px"));
      };
    }),
      n.length &&
        setTimeout(function () {
          return n[0].click();
        }, 750);
  })(),
  (function (n) {
    window.addEventListener("DOMContentLoaded", function () {
      "product" === n.template.name &&
        (document.getElementById("product-gallery-zoom").onclick = function () {
          var e = document.querySelectorAll(".pswp")[0],
            t = n.product.media
              .filter(function (e) {
                return "image" === e.media_type;
              })
              .map(function (e) {
                return { src: e.src, w: e.width, h: e.height, title: e.alt };
              }),
            o = {
              index: +document.getElementById("image-view").querySelector(".slick-current").getAttribute("data-slick-index"),
              shareEl: !1,
              fullscreenEl: !1,
              captionEl: !1,
              closeOnScroll: !1,
              hideAnimationDuration: 0,
              showAnimationDuration: 0,
            };
          new PhotoSwipe(e, PhotoSwipeUI_Default, t, o).init();
        });
    });
  })((window.theme = window.theme || {}));

  const faqToggles = document.querySelectorAll('.faq-toggle');
  faqToggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const answer = toggle.nextElementSibling;
      answer.classList.toggle('active');
    });
  });
